/*
 * @Description: 最强姓氏排行榜
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-03 09:57:09
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-14 11:14:15
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Divider } from 'antd'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/bar'
import styles from './styles.css'
import NHFetch from '../../utils/NHFetch.js'

const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const errMaxCount = 3 // 请求异常最大次数
const speed = 60 * 1000 //轮询时间间隔

class _RightTopBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errCount: 0, //连续请求错误次数
      barData: [], //各专业新生人数
    }
    this.polling //轮询定时器
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    //组件卸载时清除轮询定时器
    if (this.polling) {
      clearTimeout(this.polling)
    }
  }

  getData = () => {
    const num = 5 //排行前五 
    NHFetch(
      `${yxxtBasicUrl}/sstj/getNewStudentSurnameRankSituationByLcid?num=${num}&pkid=${this.props.pkid}`,
      'GET'
    )
      .then(res => {
        if (res && res.data) {
          //由于专业新生人数是一开始就确定的，所以这里只有当出现异常的时候才进行轮询尝试
          this.setState({ errCount: 0, barData: res.data })
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          if (this.polling) {
            clearTimeout(this.polling)
          }
        }
      })
  }

  /* 构造条形图 */
  getBarOption = () => {
    let { barData = [] } = this.state
    const { rem } = this.props
    /* 模拟数据 */
    //TODO:模拟数据
    // barData = [
    //     { surname: '陈', surnameCount: 10 },
    //     { surname: '林', surnameCount: 20 },
    //     { surname: '李', surnameCount: 7 },
    //     { surname: '张', surnameCount: 5 },
    //     { surname: '王', surnameCount: 1 },
    // ]
    barData = barData.slice(1)
    // y轴标题
    let yAxisTitles = barData.map(item => {
      return item.surname ? item.surname : ''
    })

    // y轴值
    let yAxisData = barData.map(item => {
      return item.surnameCount ? item.surnameCount : 0
    })
    // console.log('yAxisData:', yAxisData)
    const option = {
      grid: {
        left: '3%',
        right: '7%',
        top: 0,
        bottom: 30,
        containLabel: true,
      },
      xAxis: {
        show: false, //不展示x轴label
      },
      yAxis: [
        {
          show: true,
          data: yAxisTitles,
          inverse: true, //让Y轴数据逆向
          axisLine: {
            show: false,
          }, //不展示线
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: (value, index) => {
              let label = `{lg|${index + 2}}  {title|${value}}`
              if (index === 0) label = `{lg2|${index + 2}}  {title|${value}}`
              if (index === 1) label = `{lg3|${index + 2}}  {title|${value}}`
              return label
            },
            textStyle: {
              fontSize: 0.14 * rem,
            },
            rich: {
              lg: {
                backgroundColor: '#9EA5C7',
                color: '#FEFFFF',
                borderRadius: 0.18 * rem,
                align: 'center',
                width: 0.18 * rem,
                height: 0.18 * rem,
              },
              lg2: {
                backgroundColor: '#F7AC42',
                color: '#FEFFFF',
                borderRadius: 0.18 * rem,
                align: 'center',
                width: 0.18 * rem,
                height: 0.18 * rem,
              },
              lg3: {
                backgroundColor: '#2BB3F3',
                color: '#FEFFFF',
                borderRadius: 0.18 * rem,
                align: 'center',
                width: 0.18 * rem,
                height: 0.18 * rem,
              },
              title: {
                color: '#FFFFFF',
              },
            },
          },
        },
        {
          show: true,
          inverse: true,
          data: yAxisData,
          axisLabel: {
            formatter: (value, index) => {
              return `${value}人`
            },
            textStyle: {
              fontSize: 0.14 * rem,
              color: '#7F90FF',
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
      ],
      series: [
        {
          name: '条',
          type: 'bar',
          barMaxWidth: 0.14 * rem,
          barMinHeight: 1,
          yAxisIndex: 0,
          data: yAxisData,
          silent: false,
          barCategoryGap: '60%',
          itemStyle: {
            normal: {
              barBorderRadius: 0.2 * rem,
              color: {
                type: 'bar',
                colorStops: [
                  {
                    offset: 0,
                    color: '#E6C2FF', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#7F90FF', // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
          },
        },
      ],
    }
    return option
  }

  render() {
    const { barData = [] } = this.state
    return (
      <div className='rightTopBox' style={{ width: '100%', height: '100%' }}>
        <span className={styles.box_title}>最强姓氏排行榜</span>
        <div className={styles.box_3_r_top}>
          <div className={styles.box_3_l}>
            <span className={styles.span_color_x}>
              {barData.length > 0 ? barData[0].surname : ''}
            </span>
          </div>
          <div className={styles.box_3_r}>
            <span className={styles.span_color_x1}>最强姓氏</span>
            <span className={styles.span_color_x2}>
              {barData.length > 0 ? barData[0].surnameCount : 0}人
            </span>
          </div>
        </div>
        <Divider dashed className='color' />
        <ReactEchartsCore
          style={{ width: '95%', height: '55%' }}
          echarts={echarts}
          option={this.getBarOption()}
          notMerge={true}
          lazyUpdate={true}
        />
        <style jsx='true' global='true'>
          {`
            .rightTopBox .ant-divider-horizontal {
              margin: 10px 0;
            }
            .color {
              border-color: #2ba8ff;
            }
          `}
        </style>
      </div>
    )
  }
}

_RightTopBox.defaultProps = {}

_RightTopBox.propTypes = {
  rem: PropTypes.number,
}

export default _RightTopBox



// WEBPACK FOOTER //
// ./containers/Show-new/_RightTopBox.js